import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AuthProvider } from './lib/auth';
const AdminPage = lazy(() => import('./pages/AdminPage').then(m => ({ default: m.AdminPage })));
export default function App(){ return <AuthProvider><BrowserRouter><Routes><Route path="/" element={<HomePage/>}/><Route path="/admin" element={<Suspense fallback={<div className="admin-login">Cargando administración...</div>}><AdminPage/></Suspense>}/></Routes></BrowserRouter></AuthProvider>; }
